
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "updateBlockgroupOnScenario",
      resolverType: "mutation",
      routePath: "/updateBlockgroupOnScenario",
      httpMethod: "POST",
    });
  